import * as React from "react";
import ResizeObserver from "resize-observer-polyfill";

const useSize = <T extends HTMLElement>(options?: {
  timeoutMs: number;
}): [React.RefObject<T | null>, { width: number; height: number }] => {
  const elementRef = React.useRef<T>(null);
  const timeoutRef = React.useRef<number>(undefined);
  const [size, setSize] = React.useState({ width: 0, height: 0 });

  React.useEffect(() => {
    const observer = new ResizeObserver((entries) => {
      const entry = entries[0].target as T;
      const update = (): void =>
        setSize(
          elementRef.current
            ? { width: entry.offsetWidth, height: entry.offsetHeight }
            : { width: window.innerWidth, height: window.innerHeight },
        );

      if (options) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = window.setTimeout(update, options.timeoutMs);
      } else {
        update();
      }
    });

    observer.observe(elementRef.current || document.body);

    return () => observer.disconnect();
  }, [elementRef]);

  return [elementRef, size];
};

export default useSize;
